
  import {Vue} from "vue-property-decorator";
  import Component from "vue-class-component";
  import { Alert } from "../../addons/Alert";
  //import { http } from "@/config/HttpClient";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import router from "../../router";
  import EditarForm from "./EditarForm.vue"
  
  @Component({
    name: "VentaAguaIndex",
    components: {EditarForm}
  })
  export default class VentaAguaIndex extends Vue {
    
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    public swEditar = false;
    public cita_selected = null
    datos2 = [];
    fecha = DateTime.now().toFormat('yyyy-MM-dd');
    get datos(): any {
      return this.consultorioStore.consultas;
    }
    public fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
    public fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
    public txtSearch = "";
    isObservar = false
    mounted(){
      this.getConsultas();
      this.consultorioService.getConvenios();
    }
    async getConsultas(){
      this.loading
      let data = {
        fechaInicial: this.fechaInicial,
        fechaFinal: this.fechaFinal,
        txtSearch: this.txtSearch,
        page: this.pagination.current_page,
      }
      await this.consultorioService.getConsultas(data)
        
    }
    nuevo(){
      router.push({name: 'nueva-cita'});
    }
    editar(cita:any){
      this.cita_selected = cita;
      this.swEditar = true;
    }
    nuevoDespacho(){
      router.push({name: 'nuevoDespacho'});
    }
    
    get pagination(): any {
      return this.consultorioStore.pagination;
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    
  }
  